var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Exclamation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25413 3.09956C9.01874 1.74025 10.9758 1.74025 11.7404 3.09956L17.3207 13.0201C18.0707 14.3533 17.1072 16.0006 15.5776 16.0006H4.41697C2.88732 16.0006 1.92389 14.3533 2.67382 13.0201L8.25413 3.09956ZM10.9972 13.0007C10.9972 13.553 10.5495 14.0007 9.99719 14.0007C9.44491 14.0007 8.99719 13.553 8.99719 13.0007C8.99719 12.4484 9.44491 12.0007 9.99719 12.0007C10.5495 12.0007 10.9972 12.4484 10.9972 13.0007ZM9.99719 5.00073C9.44491 5.00073 8.99719 5.44845 8.99719 6.00073V9.00073C8.99719 9.55302 9.44491 10.0007 9.99719 10.0007C10.5495 10.0007 10.9972 9.55302 10.9972 9.00073V6.00073C10.9972 5.44845 10.5495 5.00073 9.99719 5.00073Z",
    fill: "#EF4444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/Exclamation.a0a5d74c0f0340cd47f8e67839415b07.svg";
export { ForwardRef as ReactComponent };